import { render, staticRenderFns } from "./GrupoNcmForm.vue?vue&type=template&id=615a634c"
import script from "./GrupoNcmForm.vue?vue&type=script&lang=js"
export * from "./GrupoNcmForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports